import { useMutation } from '@tanstack/react-query';
import { pb } from '@/core/api';

type Identity = {
  ig_username?: string;
  email?: string;
  phone?: string;
  fingerprint?: string;
  ip?: string;
};

type CheckResult = {
  blocked: boolean;
  reason?: string;
  expires_at?: string | null;
};
type FormResult = {
  passed: boolean;
  retry_at?: string;
  form_score?: number;
  session_token?: string;
  expires_at?: string;
  blocked?: boolean;
  reason?: string;
};
type CommitResult = { passed: boolean };

type SignupPayload = {
  session_token: string;
  first_name: string;
  last_name: string;
  ig_username: string;
  email: string;
  phone: string;
  country: string;
  city: string;
  birthdate: string;
  usdc_wallet?: string;
  password: string;
};

type SignupResult = {
  success?: boolean;
  token?: string;
  blocked?: boolean;
  error?: string;
  reason?: string;
  member?: Record<string, unknown>;
};

function send<T>(path: string, body: unknown): Promise<T> {
  return pb.send(path, { method: 'POST', body });
}

export function useCheckIdentity(): ReturnType<
  typeof useMutation<CheckResult, Error, Identity>
> {
  return useMutation({
    mutationFn: (id: Identity) =>
      send<CheckResult>('/api/registration/check-identity', id),
  });
}

export function useSubmitForm(): ReturnType<
  typeof useMutation<
    FormResult,
    Error,
    { answers: string[]; identity: Identity }
  >
> {
  return useMutation({
    mutationFn: (data) =>
      send<FormResult>('/api/registration/submit-form', data),
  });
}

export function useCommitment(): ReturnType<
  typeof useMutation<
    CommitResult,
    Error,
    { session_token: string; answer: string }
  >
> {
  return useMutation({
    mutationFn: (data) =>
      send<CommitResult>('/api/registration/commitment', data),
  });
}

export function useSignup(): ReturnType<
  typeof useMutation<SignupResult, Error, SignupPayload>
> {
  return useMutation({
    mutationFn: (data) => send<SignupResult>('/api/registration/signup', data),
  });
}
